import { ErrorMessage, Field, FormikProvider, useFormik } from 'formik'
import React, {  useEffect,  useState } from 'react'
import { CommonPageHeading } from '../../../CommonUtils/CommonHeading/CommonPageHeading';
import * as jnb from 'react-bootstrap';
import Sweetalert from '../../../CommonUtils/CommonPopupAndAlerts/SweetAlerts';
import { config } from '../../../CommonUtils/CommonUrl/CommonUrls';
import { CommonAxiosPost } from '../../../CommonUtils/CommonAxios/CommonAxios';
import { useSelector } from 'react-redux';
import Header from '../../../Header/Header';
import {  useLocation } from 'react-router-dom';
import Swal from 'sweetalert2';
import * as Yup from "yup";
import { ERROR_MSG } from '../../../CommonUtils/Validations/RegularExpAndVar';
import {  ApprovalReportData } from './ApprovalReportData';
export default function ApprovalPrint() {
    const loginreducer = useSelector((state) => state?.reducers?.loginreducer?.loginDetails?.loginData);
    const [showList, setList] = useState([]);
    const location = useLocation();
    const data = location?.state?.data
    const [isApproved, setIsApproved] = useState(false);
    const InWardValidation =
        Yup.object().shape({
            approval_remarks: Yup.string().required(ERROR_MSG)
        })
    const Formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            entry_by: loginreducer?.username,
            approval_remarks: "",
            is_approval_confirm: "",
            "incharge_cfms_id": data?.incharge_cfms_id,
            "in_ward_cheque_in_date": data?.in_ward_cheque_in_date,
            "approval_cfms_id": loginreducer?.username,
            "checker_cfms_id": data?.incharge_cfms_id,
        },
        onSubmit: (values) => {
            let msg = "Do you want to send back to Checker?"
            Swal.fire({
                title: "Are you sure ?",
                text: msg,
                icon: "question",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes",
                cancelButtonText: "No"
            }).then((save) => {
                if (save.isConfirmed) {
                    FinalSubmit(values)
                }
            })
        },
        validationSchema: InWardValidation
    })

    const GetChequeInReport = () => {
        let url = config.url.BOC_URL + "inward-datewise-approver";
        let values = {
            "in_ward_cheque_in_date": data?.in_ward_cheque_in_date,
            "incharge_cfms_id": data?.incharge_cfms_id
        }
        return CommonAxiosPost(url, values).then((response) => {
            if (response.data.status === true) {
                setList(response.data.date_wise_report);
                setIsApproved(response?.data?.date_wise_report[0].is_approver_confirmed)
            }
            else {
                setIsApproved(false)
                setList([])
            }
        })
    }
    function FinalSubmit(values) {
        let url = config.url.BOC_URL + "inward-approver-confirmation";
        CommonAxiosPost(url, values).then((res) => {
            if (res?.data?.scode === '01') {
                if (values.is_approval_confirm === true) {
                    setIsApproved(true)
                    Formik.setFieldValue("is_approval_confirm", true)
                    Sweetalert("SuccessFully Saved Your Response", 'success')
                }
                else {
                    Sweetalert("SuccessFully send back to Maker", 'success')
                }

                GetChequeInReport()
            }
            else if (res.data.scode === '02') {
                Sweetalert(res.data.sdesc, 'warning')
            }

        })
    }
    function SaveOptions(value) {
        let values = {
            "in_ward_cheque_in_date": data?.in_ward_cheque_in_date,
            "approval_cfms_id": loginreducer?.username,
            "incharge_cfms_id": data?.incharge_cfms_id,
            "is_approval_confirm": value
        }
        FinalSubmit(values)
    }
    useEffect(() => {
        GetChequeInReport()
    }, [])
  

    return (
        <React.Fragment>
            <Header />
            <div className="main_section"> </div>
            <CommonPageHeading heading="Approval Report" />
            <jnb.Container className="outer-page-content-container" >
                {isApproved === true ?
                    <ApprovalReportData showList={showList}/>    
                    
                    :
                    <FormikProvider value={Formik}>
                        <jnb.Form onChange={Formik.handleChange} onSubmit={Formik.handleSubmit} className="form_adjust">
                            <div className="table-responsive">
                            <ApprovalReportData showList={showList}/>                               
                            </div>
                            {showList?.length > 0 ?
                                <jnb.Row>
                                    <jnb.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="page-titlespacing d-flex justify-content-between px-0">
                                        <div className='text-left px-2'>
                                            <label>Remarks</label>
                                            <jnb.InputGroup>                                        
                                                <Field type="text" name="approval_remarks" className="form-control" />
                                                 &emsp;
                                                <button type="submit" className="btn btn-danger btn-md"> Back to Maker</button>
                                                </jnb.InputGroup>
                                                <ErrorMessage name="approval_remarks" component="div" className="text-error" />
                                        </div>
                                      
                                        <div className="text-right px-2">
                                        <button type="button" onClick={() => { SaveOptions(true) }} className="btn btn-success btn-md"> Confirm</button>
                                        </div>
                                    </jnb.Col>
                                </jnb.Row> : <React.Fragment></React.Fragment>}

                           
                        </jnb.Form>
                    </FormikProvider>
                   
                }
            </jnb.Container>




        </React.Fragment>
    )
}
